import type { ArrivalStepResponse, UpsertArrivalStepRequest } from '@/shared/api';

export interface ArrivalStepDraft {
  titleDe: string;
  bodyDe: string;
  titleEn: string;
  bodyEn: string;
  timeLocked: boolean;
}

export type ArrivalFieldKey = 'titleDe' | 'bodyDe' | 'titleEn' | 'bodyEn';

export const emptyArrivalDraft = (): ArrivalStepDraft => ({
  titleDe: '',
  bodyDe: '',
  titleEn: '',
  bodyEn: '',
  timeLocked: false,
});

export const toArrivalDraft = (step: ArrivalStepResponse): ArrivalStepDraft => ({
  titleDe: step.titleDe,
  bodyDe: step.bodyDe,
  titleEn: step.titleEn ?? '',
  bodyEn: step.bodyEn ?? '',
  timeLocked: step.visibility === 'KeyCodeWindow',
});

export const toUpsertRequest = (draft: ArrivalStepDraft): UpsertArrivalStepRequest => ({
  titleDe: draft.titleDe.trim(),
  bodyDe: draft.bodyDe.trim(),
  titleEn: draft.titleEn.trim() || null,
  bodyEn: draft.bodyEn.trim() || null,
  visibility: draft.timeLocked ? 'KeyCodeWindow' : 'Always',
});

export const sameDraft = (a: ArrivalStepDraft, b: ArrivalStepDraft) =>
  JSON.stringify(toUpsertRequest(a)) === JSON.stringify(toUpsertRequest(b));
